import { clientFor, type PageQuery, type PageResult } from '@yc/api-client'

const api = clientFor('/wms/api')

/** 模块：日志落在哪个业务域。与后端 internal/oplog/model.go 的 ModuleNames 同源两份 */
export type ModuleKey = 'inbound' | 'outbound' | 'wave' | 'stocktake' | 'stock'

/** 动作：单据状态变更与库存动作的动词。与后端 ActionNames 同源两份 */
export type ActionKey =
  | 'create'
  | 'delete'
  | 'release'
  | 'cancel'
  | 'close'
  | 'receive'
  | 'putaway'
  | 'ship'
  | 'import'
  | 'task'
  | 'complete'
  | 'start'
  | 'count'
  | 'confirm'
  | 'transfer'

export const MODULE_LABELS: Record<ModuleKey, string> = {
  inbound: '入库',
  outbound: '出库',
  wave: '波次',
  stocktake: '盘点',
  stock: '库存',
}

export const ACTION_LABELS: Record<ActionKey, string> = {
  create: '创建',
  delete: '删除',
  release: '释放',
  cancel: '取消',
  close: '关闭',
  receive: '收货',
  putaway: '上架',
  ship: '发货',
  import: '导入',
  task: '拣货',
  complete: '复核发货',
  start: '开始',
  count: '提交盘点',
  confirm: '确认差异',
  transfer: '移库',
}

/** 一条操作日志：谁在什么时候对哪张单做了什么 */
export interface OpLog {
  id: number
  module: string
  action: string
  ref_type: string
  ref_no: string
  summary: string
  operator: string
  created_at: string
}

export interface OpLogQuery extends PageQuery {
  module?: string
  action?: string
  keyword?: string
  from?: string
  to?: string
}

export const listOpLogs = (q: OpLogQuery): Promise<PageResult<OpLog>> =>
  api.get<PageResult<OpLog>>('/op-logs', { ...q })
